import { render, staticRenderFns } from "./ResultadoAntecipacao.vue?vue&type=template&id=6524dd50&scoped=true&"
import script from "./ResultadoAntecipacao.vue?vue&type=script&lang=js&"
export * from "./ResultadoAntecipacao.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoAntecipacao.vue?vue&type=style&index=0&id=6524dd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524dd50",
  null
  
)

export default component.exports